// extracted by mini-css-extract-plugin
export var skipLink = "fN_vw";